import { Outlet } from "react-router";
import { CMSProvider } from "src/context/Settings/CMS/CMSProvider";
import { MODIFY } from "src/context/FoodpilotContext";
import { CMSPagesProtection } from "./CMSPagesProtection";

export const CMSRouteContext = () => (
    <CMSPagesProtection action={MODIFY}>
        <CMSProvider>
            <Outlet />
        </CMSProvider>
    </CMSPagesProtection>
);
